import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
// import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
// import StockStore from 'stores/StockStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';
const WHOLE_YEAR = momentHelper.getMonth() //'00'
class ReportColor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      activePage:1,
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      data:[],
      // dataFormat:[],
      isRange:false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      isSubMenu:false,
      subMenu:[],
      dataDetail:[],
      showDetail:false,
      description:'',
      productcode:''
    }
    this.refTableId = 'ReportColor-'+Math.ceil(Math.random()*100);
    this.refTableDetailId = 'ReportColorDetail-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  getDetailSummary(field) {
    let {dataDetail} = this.state
    let total = 0
    dataDetail.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadData(year='',month='',day='') {  
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadUsageVolume(year,month,day,(result)=>{
        this.setState({loading:false,data:result.data})
    })  
  }

  loadDataRange(start='',end='') {
    ReportStore.loadUsageVolumeRange(start,end,(result)=>{
        this.setState({loading:false,data:result.data})
    })
  }

  onTableDetailCloseClick() {
    this.setState({subMenu:[],isSubMenu:false,description:'',productcode:'',showDetail:false,dataDetail:[]},()=>{
        if (this.props.onUpdateEventKey!=undefined)
          this.props.onUpdateEventKey(undefined)
      })
  }

  onRowClick(item) {
    let {year,month} = this.state
    this.setState({loading:true,description:item.description,productcode:item.productcode,subMenu:[{title:item.description+' รหัสสินค้า '+item.productcode,key:'s'+0}],isSubMenu:true},()=>{
        if (this.props.onUpdateEventKey!=undefined)
            this.props.onUpdateEventKey('s'+0)
    })
    ReportStore.loadUsageVolumeDetail(year,month,item.productcode,(result)=>{
        this.setState({loading:false,dataDetail:result.data,showDetail:true})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-center'>{this.getNumberFormat(item.usage_quantity)}</td>
              <td className='text-center'>{item.unit_quantity}</td>
              <td className='text-right'>{'0.00'}</td>
              <td className='text-center'><Button bsStyle='default' onClick={this.onRowClick.bind(this,item)}><FontAwesome name='search' />&nbsp;ดูรายละเอียด</Button></td>
            </tr>
        ) 
      )  
    }
  }

  renderBodyDetail() {
    let {dataDetail} = this.state
    if (dataDetail.length==0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            dataDetail.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>{item.car_registration_no}</td>
                        <td className='text-center'>{item.productcode}</td>
                        <td className='text-center'>{item.description}</td>                        
                        <td className='text-center'>{this.getNumberFormat(item.usage_quantity)}</td>
                        <td className='text-center'>{item.technician}</td>
                        <td className='text-right'>{item.remark}</td>
                    </tr>
                )
            })
        )    
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00'||day===0) {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid' style={{minWidth:'1400px'}}>
          <thead>
            <tr>
              <th style={{display:'none'}} className='text-center' colSpan={7}>รายงานการใช้สีประจำเดือน {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'150px'}}>ชื่อสี</th>
              <th className='text-center' style={{width:'200px'}}>คำอธิบาย</th>
              <th className='text-center' style={{width:'100px'}}>ปริมาณการใช้ (กรัม)</th>
              <th className='text-center' style={{width:'100px'}}>เป็นจำนวน (กระป๋อง)</th>
              <th className='text-center' style={{width:'100px'}}>รวมมูลค่า</th>
              <th className='text-center' style={{width:'100px'}}></th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={3} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('usage_quantity'))}</th>
              <th className='text-center'>{this.getSummary('unit_quantity')}</th>
              <th className='text-right'>{'0.00'}</th>
              <th className='text-right'></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderTableDetail() {
    return (
        <div className='display-overflow'>
          <table id={this.refTableDetailId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income'>
            <thead>
              <tr style={{display:'none'}}>
                <th colSpan={3}>คำอธิบาย : {this.state.description}</th>
                <th colSpan={3}>รหัสสินค้า : {this.state.productcode}</th>
                <th></th>
              </tr>  
              <tr>
                <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
                <th className='text-center' style={{width:'120px'}}>เลขทะเบียน</th>
                <th className='text-center' style={{width:'100px'}}>รหัสสินค้า</th>
                <th className='text-center' style={{width:'200px'}}>คำอธิบาย</th>
                <th className='text-center' style={{width:'100px'}}>ปริมาณการใช้ (กรัม)</th>
                <th className='text-center' style={{width:'100px'}}>ช่าง</th>
                <th className='text-center' style={{width:'200px'}}>หมายเหตุ</th>
              </tr>
            </thead>
            <tbody>
              {this.renderBodyDetail()}
            </tbody>
            <tfoot>
            <tr>
              <th colSpan={4} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-center'>{this.getNumberFormat(this.getDetailSummary('usage_quantity'))}</th>
              <th className='text-right'></th>
              <th className='text-right'></th>
            </tr>
          </tfoot>
          </table>
        </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานการใช้สีประจำเดือน.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportColor&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportColor&start_date='+start+'&end_date='+end+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcelDetail(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableDetailId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานการใช้สีประจำเดือน '+this.state.description+' รหัสสินค้า '+this.state.productcode+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTableDetail(e) {
    let url = ''
    let param = 'PrintReportColorDetail&year='+this.state.year+'&month='+this.state.month+'&description='+this.state.description+'&productcode='+this.state.productcode

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderToolbarDetail() {
    return(
        <Form inline>
            <FormGroup style={{verticalAlign:'top',marginTop:'1.5px',marginBottom:'5px'}}>
                <PrintButtons
                    onPrintTable={this.onPrintTableDetail.bind(this)}
                    onExportExcel={this.onExportExcelDetail.bind(this)}
                    marginLeft='0'
                    width='auto'
                />
            </FormGroup>
        </Form>
    )    
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'รายงานการใช้สีประจำเดือน'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading,showDetail} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu(this.state.isSubMenu,this.state.subMenu)}
        </Box.Header>
        <Box.Body>
          {showDetail?this.renderToolbarDetail():this.renderToolbar()}
          {!showDetail?this.renderDateRange():''}
          {showDetail?this.renderTableDetail():this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
        {showDetail?
        <Box.Footer>
            <div className=" pull-right">
                <Button bsStyle='default' onClick={this.onTableDetailCloseClick.bind(this)}><FontAwesome name='table' />&nbsp;กลับหน้าตารางหลัก</Button>    
            </div>
        </Box.Footer>
        :''}
      </Box>
    )
  }
}

ReportColor.defaultProps = {
  show : false
}

export default ReportColor;


// WEBPACK FOOTER //
// ./src/view/report/material/ReportColor.js